import React, { useEffect, useState, useMemo } from "react";
import { formatDateTime, formatDateToInput } from "../../Utils/common";
import DatePicker from "react-datepicker";
import Loader from "../../Utils/Loader";
import { CustomGetAPI } from "../../Utils/APIConnector";
import ResponsivePagination from "react-responsive-pagination";

export default function TransactionsTab({ type, date }) {
  const [key, setKey] = useState(type);
  const [transactionData, setTransactionData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const headers = Object.keys(transactionData[0] || {});

  useEffect(() => {
    getTransactionData();
  }, [key, date]);

  const getTransactionData = () => {
    setIsLoading(true);
    try {
      CustomGetAPI(
        `/adminstats/getrazorpaystats?type=${key}&date=${formatDateToInput(
          date
        )}`
      )
        .then((result) => {
          result = JSON.parse(result);
          if (result) {
            const list = result || [];
            setTransactionData(list);
            setCurrentPage(1);
          } else {
            setTransactionData([]);
          }
        })
        .catch((err) => {
          console.error(err);
          setTransactionData([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
      setTransactionData([]);
      setIsLoading(false);
    }
  };

  const handleSort = (header) => {
    let direction = "asc";
    if (sortConfig.key === header && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: header, direction });
  };

  // Sort data before pagination
  const sortedData = useMemo(() => {
    let sortableItems = [...transactionData];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] === null) return 1;
        if (b[sortConfig.key] === null) return -1;
        if (a[sortConfig.key] === b[sortConfig.key]) return 0;

        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        // Check if values are dates
        const aDate = new Date(aValue);
        const bDate = new Date(bValue);
        if (!isNaN(aDate) && !isNaN(bDate)) {
          return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
        }

        // Check if values are numbers
        if (!isNaN(aValue) && !isNaN(bValue)) {
          return sortConfig.direction === "asc"
            ? aValue - bValue
            : bValue - aValue;
        }

        // Sort as strings
        return sortConfig.direction === "asc"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      });
    }
    return sortableItems;
  }, [transactionData, sortConfig]);

  // client-side pagination calculations
  const totalItems = sortedData.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const visibleRows = sortedData.slice(startIdx, endIdx);

  const body = (
    <div
      style={{
        border: "1px solid #dfb3b3ff",
        padding: "5px",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      {transactionData.length === 0 && <div>No Data Available</div>}
      {transactionData.length > 0 && (
        <div
          style={{
            overflowX: "auto",
            marginTop: "5px",
          }}
        >
          <b>{key}:</b>
          <table
            border="1"
            cellPadding="8"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              background: "#f4f4f4",
            }}
            className="table bordered mt-2"
          >
            <thead>
              <tr style={{ background: "#f4f4f4" }}>
                {headers.map((header) => (
                  <th
                    key={header}
                    style={{
                      textTransform: "capitalize",
                      background: "#f4f4f4",
                      cursor: "pointer",
                      userSelect: "none",
                    }}
                    onClick={() => handleSort(header)}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      {header}
                      {sortConfig.key === header ? (
                        <>
                          {sortConfig.direction === "asc"
                            ? "  ↑"
                            : sortConfig.direction === "desc"
                            ? "  ↓"
                            : "  ↑↓"}
                        </>
                      ) : (
                        "  ↑↓"
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visibleRows?.map((row, i) => (
                <tr key={startIdx + i}>
                  {headers.map((header) => (
                    <td key={header}>
                      {header.toLowerCase().includes("amount")
                        ? `₹ ${row[header]}`
                        : header.toLowerCase().includes("created")
                        ? `${formatDateTime(row[header], "DD/MM/YY hh:mm A")}`
                        : row[header]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* pagination */}
      {totalItems > itemsPerPage && (
        <div className="d-flex justify-content-center mt-3">
          <ResponsivePagination
            total={totalPages}
            current={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </div>
  );

  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex flex-wrap gap-3">
          <label className="venue-listing-labels">
            <strong>Total Amount </strong> : {data.totalAdvanceAmount}
          </label>
          <label className="venue-listing-labels">
            <strong>Total Payout </strong> : {data.totalPaymentDone}
          </label>
          <label className="venue-listing-labels">
            <strong>CB Discount </strong> : {data.totalDiscount}
          </label>
          <label className="venue-listing-labels">
            <strong>CB Profit </strong> :{" "}
            {(
              (Number(data?.totalAdvanceAmount) || 0) -
              (Number(data.totalPaymentDone) || 0) -
              (Number(data?.totalDiscount) || 0)
            ).toFixed(2)}
          </label>
        </div>
        <div className="d-flex">
          <select
            className="form-select py-0 me-3 h-100"
            value={key}
            onChange={(e) => !isLoading && setKey(e.target.value)}
          >
            <option value="Payments">Payments</option>
            <option value="Settlements">Settlements</option>
            <option value="Payouts">Payouts</option>
          </select>
          <DatePicker
            selected={date}
            onChange={(d) => !isLoading && setDate(d)}
            dateFormat="yyyy/MM"
            showMonthYearPicker
            showFullMonthYearPicker
            className="form-control text-center border-2 mb-2 pb-1 pt-0"
          />
        </div>
      </div> */}
      {isLoading ? <Loader mt={"10%"} /> : body}
    </>
  );
}
